import { BaseComponent, IStateBase } from 'components/BaseComponent';
import UserForm from 'components/Cart/MainForm/UserForm';
import { ICartModel } from 'interfaces/ICartModel';
import { IProductConfig, IProductData } from 'interfaces/IProductData';
import Button from '@material-ui/core/Button/Button';
import Grid from '@material-ui/core/Grid/Grid';
import React from 'react';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { enStep, IStepProps } from './index';
import { FieldValidation } from 'components/Field';
import { SvgIcon } from 'components/SvgIcon';
import Translate from 'components/Translate';
import { enPaymentType } from 'enums/enPaymentType';
import { parameterService } from 'services/ParameterService';
import { validate } from 'validators';

interface IState extends IStateBase {
  cart: IProductData;
  config: IProductConfig;
  model: ICartModel;
}

export interface IProps extends IStepProps {
  onPay: () => void;
}

export default class StepUser extends BaseComponent<IState, IProps> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    parameterService.getAll()
      .bindComponent(this)
      .filter((params) => !!params.skip)
      .filter((params) => validate(params.name || params.nome, 'required|name|max:100').valid)
      .filter((params) => validate(params.email, 'required|email|max:150').valid)
      .filter((params) => validate(params.phone || params.cel, 'required|min:10|max:11').valid)
      .subscribe(() => {
        this.goToNextStep();
      });

    this.observeState({ cart: null }, cartService.getCart());
    this.bindModel(paymentService.getCart());
  }

  goToNextStep = async () => {
    if (await this.isFormValid()) {
      this.props.setStep(enStep.address);
    }
  }

  finish = () => {
    this.props.onPay();
  }

  render() {

    if (!this.state) {
      return '';
    }

    const { formSubmitted, cart } = this.state;

    const validation = this.state.validation || {};
    const isValid = Object.keys(validation).length === 0;

    const disabledButton = !isValid && formSubmitted;

    const getForFree = cart.paymentType === enPaymentType.FREE && !cart.config.askAddressBeforePayment;

    return (
      <div className='step'>
        <FieldValidation.Provider value={this.registerFields}>
          <Grid className='grid' container>
            <Grid item xs={12} className='chk-form-component'>
              <UserForm />
            </Grid>
            <small className='chk-stepUser__securityMessage'>
              <SvgIcon name='security' />
              <Translate term='Seus dados serão mantidos em sigilo' />
            </small>
            {getForFree
              ? <Button
                id='chk-free-button'
                onClick={this.finish}
                fullWidth
                variant='contained'
                size='large'
                color='primary'
                className='chk-btnContinue theme-button'
                disabled={disabledButton}
              >
                {<Translate term='Obter gratuitamente' />}
              </Button>
              : <Button
                id='chk-next-button'
                onClick={this.goToNextStep}
                fullWidth
                variant='contained'
                size='large'
                color='primary'
                className='chk-btnContinue theme-button'
                disabled={disabledButton}
              >
                <Translate term='Próximo' />
              </Button>
            }
          </Grid>
        </FieldValidation.Provider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Widget/MultiStep/StepUser.tsx